var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAquaLogo = function SvgAquaLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 88 88"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#872AB0",
    d: "M0 44C0 24.927 0 15.39 5.175 8.908a23.7 23.7 0 0 1 3.733-3.733C15.39 0 24.927 0 44 0s28.61 0 35.092 5.175a23.7 23.7 0 0 1 3.734 3.733C88 15.39 88 24.927 88 44s0 28.61-5.174 35.092a23.7 23.7 0 0 1-3.734 3.734C72.61 88 63.073 88 44 88s-28.61 0-35.092-5.174a23.7 23.7 0 0 1-3.733-3.734C0 72.61 0 63.073 0 44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m52.07 40.46 9.811 9.774 9.743-9.711 4.276 4.236-14.017 13.973-9.813-9.776L36.597 64.37l-8.303-8.27-9.939 9.9-4.275-4.237 14.214-14.16 8.303 8.271z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m52.07 23.98 9.811 9.775 9.743-9.712L75.9 28.28 61.883 42.252l-9.813-9.775L36.597 47.89l-8.303-8.271-9.939 9.9-4.275-4.237 14.214-14.16 8.303 8.271z",
    clipRule: "evenodd"
  })));
};
export default SvgAquaLogo;